import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import theme from 'site-react/theme';

const sectionStyle = (
  isFullWidth,
  isSingleColumnWidthConstrained,
  verticalPadding,
) => css`
  padding-bottom: ${theme.spacing[verticalPadding] || 0}px;
  padding-left: ${theme.spacing.md}px;
  padding-top: ${theme.spacing[verticalPadding] || 0}px;
  padding-right: ${theme.spacing.md}px;
  margin-left: auto;
  margin-right: auto;
  ${isSingleColumnWidthConstrained && !isFullWidth
    ? `max-width: ${theme.breakpoints.md}px;`
    : ''}

  @media (min-width: ${theme.breakpoints.lg}px) {
    @supports (display: grid) {
      ${!isFullWidth ? `max-width: ${theme.grid.maxWidth}px;` : ''}
    }
  }
`;

/**
 * `Section` is used to compose components into vertical page layouts.
 */
const Section = ({
  children,
  id,
  isFullWidth,
  isSingleColumnWidthConstrained,
  verticalPadding,
}) => {
  const sectionProps = {};

  if (id) {
    sectionProps.id = id;
  }

  return (
    <div
      className={sectionStyle(
        isFullWidth,
        isSingleColumnWidthConstrained,
        verticalPadding,
      )}
      {...sectionProps}
    >
      {children}
    </div>
  );
};

Section.defaultProps = {
  children: null,
  id: null,
  isFullWidth: false,
  isSingleColumnWidthConstrained: true,
  verticalPadding: null,
};

Section.propTypes = {
  /**
   * Content to display in the Section.
   */
  children: PropTypes.node,

  /**
   * ID to allow for # navigation
   */
  id: PropTypes.string,

  /**
   * Should the width of this Section be unconstrained (filling the viewport)?
   */
  isFullWidth: PropTypes.bool,

  /**
   * Below the lg breakpoint, should the width of this Section be constrained
   * to the width of the md breakpoint?
   */
  isSingleColumnWidthConstrained: PropTypes.bool,

  /**
   * The amount of spacing to apply eqaully to top & bottom of the Section.
   */
  verticalPadding: PropTypes.oneOf(Object.keys(theme.spacing)),
};

export default Section;
